import React from "react";
import { useTheme } from "@mui/material/styles";
import { BsFileEarmarkExcelFill, BsFileEarmarkWordFill } from "react-icons/bs";
import PolicyPdfIcon from "./PolicyPdfIcon";

interface ContractFileTypeIconProps {
  fileName?: string;
}

// Picks the file-type icon from the extension of fileName; falls back to the PDF icon.
const ContractFileTypeIcon: React.FC<ContractFileTypeIconProps> = ({
  fileName,
}) => {
  const theme = useTheme();
  const extension = (fileName || "").trim().toLowerCase().split(".").pop();

  if (extension === "doc" || extension === "docx") {
    const WordIcon = BsFileEarmarkWordFill as any;
    return (
      <WordIcon
        color={theme.palette.custom.fileWordBlue}
        data-testid="contract-word-icon"
      />
    );
  }

  if (extension === "xls" || extension === "xlsx") {
    const ExcelIcon = BsFileEarmarkExcelFill as any;
    return (
      <ExcelIcon
        color={theme.palette.custom.fileExcelGreen}
        data-testid="contract-excel-icon"
      />
    );
  }

  return <PolicyPdfIcon />;
};

export default ContractFileTypeIcon;
